export const POPER_CONFIG = {
  placement: 'bottom',
  modifiers: [{ name: 'offset', options: { offset: [0, 15] } }],
};

export const INPUT_MAX_LENGT = 100;
